import React from 'react'
import { FormSectionTwoColumns } from '../../../../../../../components/forms/FormSectionTwoColumns'
import { RichTextInput } from '../../../../../../../components/inputs/RichTextInput/RichTextInput'
import { Field, FormikProps, useFormikContext } from 'formik'
import { CheckboxInput } from '../../../../../../../components/inputs/CheckboxInput'
import RadioInput from '../../../../../../../components/inputs/RadioInput'
import { TextInput } from '../../../../../../../components/inputs/TextInput'

interface Props {}

export const DemolitionTechnicalFormB2: React.FC<Props> = () => {
  const formik = useFormikContext() as FormikProps<any>
  return (
    <FormSectionTwoColumns
      title="B.2 Připojení na technickou infrastrukturu"
      subtitle="Napojovací místa technické infrastruktury, připojovací rozměry, výkonové kapacity a délky, způsob odpojení."
      sectionKey="b2.technicalInfrastructure"
    >
      <>
        <div className="sm:col-span-6">
          <Field
            name="b2.technicalInfrastructure.waterSupply.enabled"
            component={CheckboxInput}
            label="Vodovod"
          />
          {formik.values.b2?.technicalInfrastructure?.waterSupply?.enabled && (
            <>
              <div className="pl-7 mt-3">
                <span className="text-sm">Přípojka</span>
                <Field
                  name="b2.technicalInfrastructure.waterSupply.connectionCondition"
                  component={RadioInput}
                  options={[
                    { label: 'Stávající', value: 'existing' },
                    { label: 'Nová', value: 'new' },
                    { label: 'Rekonstruovaná', value: 'reconstructed' },
                    { label: 'Bez přípojky', value: 'none' },
                  ]}
                />
              </div>
              {formik.values.b2?.technicalInfrastructure?.waterSupply?.connectionCondition !== 'none' && (
                <>
                  <div className="pl-7 mt-3">
                    <span className="text-sm">Materiál a dimenze</span>
                    <Field
                      name="b2.technicalInfrastructure.waterSupply.material"
                      component={TextInput}
                    />
                  </div>
                  <div className="pl-7 mt-3">
                    <span className="text-sm">Délka</span>
                    <Field
                      name="b2.technicalInfrastructure.waterSupply.length"
                      component={TextInput}
                    />
                  </div>
                  <div className="pl-7 mt-3">
                    <span className="text-sm">Připojovací rozměr</span>
                    <Field
                      name="b2.technicalInfrastructure.waterSupply.connectionDimension"
                      component={TextInput}
                    />
                  </div>
                  <div className="pl-7 mt-3">
                    <span className="text-sm">Výkonová kapacita</span>
                    <Field
                      name="b2.technicalInfrastructure.waterSupply.performanceCapacity"
                      component={TextInput}
                    />
                  </div>
                </>
              )}
              <div className="pl-7 mt-3">
                <Field
                  name="b2.technicalInfrastructure.waterSupply.description"
                  component={RichTextInput}
                  aiHint="Napojovací místa technické infrastruktury - Vodovod - Popis"
                />
              </div>
            </>
          )}
        </div>

        <div className="sm:col-span-6">
          <Field
            name="b2.technicalInfrastructure.sewage.enabled"
            component={CheckboxInput}
            label="Splašková kanalizace"
          />
          {formik.values.b2?.technicalInfrastructure?.sewage?.enabled && (
            <>
              <div className="pl-7 mt-3">
                <span className="text-sm">Přípojka</span>
                <Field
                  name="b2.technicalInfrastructure.sewage.connectionCondition"
                  component={RadioInput}
                  options={[
                    { label: 'Stávající', value: 'existing' },
                    { label: 'Nová', value: 'new' },
                    { label: 'Rekonstruovaná', value: 'reconstructed' },
                    { label: 'Bez přípojky', value: 'none' },
                  ]}
                />
              </div>
              {formik.values.b2?.technicalInfrastructure?.sewage?.connectionCondition !== 'none' && (
                <>
                  <div className="pl-7 mt-3">
                    <span className="text-sm">Materiál a dimenze</span>
                    <Field
                      name="b2.technicalInfrastructure.sewage.material"
                      component={TextInput}
                    />
                  </div>
                  <div className="pl-7 mt-3">
                    <span className="text-sm">Délka</span>
                    <Field
                      name="b2.technicalInfrastructure.sewage.length"
                      component={TextInput}
                    />
                  </div>
                  <div className="pl-7 mt-3">
                    <span className="text-sm">Připojovací rozměr</span>
                    <Field
                      name="b2.technicalInfrastructure.sewage.connectionDimension"
                      component={TextInput}
                    />
                  </div>
                  <div className="pl-7 mt-3">
                    <span className="text-sm">Výkonová kapacita</span>
                    <Field
                      name="b2.technicalInfrastructure.sewage.performanceCapacity"
                      component={TextInput}
                    />
                  </div>
                </>
              )}
              <div className="pl-7 mt-3">
                <Field
                  name="b2.technicalInfrastructure.sewage.description"
                  component={RichTextInput}
                  aiHint="Napojovací místa technické infrastruktury - Splašková kanalizace - Popis"
                />
              </div>
            </>
          )}
        </div>

        <div className="sm:col-span-6">
          <Field
            name="b2.technicalInfrastructure.gasPipeline.enabled"
            component={CheckboxInput}
            label="Plynovod"
          />
          {formik.values.b2?.technicalInfrastructure?.gasPipeline?.enabled && (
            <>
              <div className="pl-7 mt-3">
                <span className="text-sm">Přípojka</span>
                <Field
                  name="b2.technicalInfrastructure.gasPipeline.connectionCondition"
                  component={RadioInput}
                  options={[
                    { label: 'Stávající', value: 'existing' },
                    { label: 'Nová', value: 'new' },
                    { label: 'Rekonstruovaná', value: 'reconstructed' },
                    { label: 'Bez přípojky', value: 'none' },
                  ]}
                />
              </div>
              {formik.values.b2?.technicalInfrastructure?.gasPipeline?.connectionCondition !== 'none' && (
                <>
                  <div className="pl-7 mt-3">
                    <span className="text-sm">Materiál a dimenze</span>
                    <Field
                      name="b2.technicalInfrastructure.gasPipeline.material"
                      component={TextInput}
                    />
                  </div>
                  <div className="pl-7 mt-3">
                    <span className="text-sm">Délka</span>
                    <Field
                      name="b2.technicalInfrastructure.gasPipeline.length"
                      component={TextInput}
                    />
                  </div>
                  <div className="pl-7 mt-3">
                    <span className="text-sm">Připojovací rozměr</span>
                    <Field
                      name="b2.technicalInfrastructure.gasPipeline.connectionDimension"
                      component={TextInput}
                    />
                  </div>
                  <div className="pl-7 mt-3">
                    <span className="text-sm">Výkonová kapacita</span>
                    <Field
                      name="b2.technicalInfrastructure.gasPipeline.performanceCapacity"
                      component={TextInput}
                    />
                  </div>
                </>
              )}
              <div className="pl-7 mt-3">
                <Field
                  name="b2.technicalInfrastructure.gasPipeline.description"
                  component={RichTextInput}
                  aiHint="Napojovací místa technické infrastruktury - Plynovod - Popis"
                />
              </div>
            </>
          )}
        </div>

        <div className="sm:col-span-6">
          <Field
            name="b2.technicalInfrastructure.wiring.enabled"
            component={CheckboxInput}
            label="Vedení NN"
          />
          {formik.values.b2?.technicalInfrastructure?.wiring?.enabled && (
            <>
              <div className="pl-7 mt-3">
                <span className="text-sm">Přípojka</span>
                <Field
                  name="b2.technicalInfrastructure.wiring.connectionCondition"
                  component={RadioInput}
                  options={[
                    { label: 'Stávající', value: 'existing' },
                    { label: 'Nová', value: 'new' },
                    { label: 'Rekonstruovaná', value: 'reconstructed' },
                    { label: 'Bez přípojky', value: 'none' },
                  ]}
                />
              </div>
              {formik.values.b2?.technicalInfrastructure?.wiring?.connectionCondition !== 'none' && (
                <>
                  <div className="pl-7 mt-3">
                    <span className="text-sm">Materiál a dimenze</span>
                    <Field
                      name="b2.technicalInfrastructure.wiring.material"
                      component={TextInput}
                    />
                  </div>
                  <div className="pl-7 mt-3">
                    <span className="text-sm">Délka</span>
                    <Field
                      name="b2.technicalInfrastructure.wiring.length"
                      component={TextInput}
                    />
                  </div>
                  <div className="pl-7 mt-3">
                    <span className="text-sm">Připojovací rozměr</span>
                    <Field
                      name="b2.technicalInfrastructure.wiring.connectionDimension"
                      component={TextInput}
                    />
                  </div>
                  <div className="pl-7 mt-3">
                    <span className="text-sm">Výkonová kapacita</span>
                    <Field
                      name="b2.technicalInfrastructure.wiring.performanceCapacity"
                      component={TextInput}
                    />
                  </div>
                </>
              )}
              <div className="pl-7 mt-3">
                <Field
                  name="b2.technicalInfrastructure.wiring.description"
                  component={RichTextInput}
                  aiHint="Napojovací místa technické infrastruktury - Vedení nízkého napětí - Popis"
                />
              </div>
            </>
          )}
        </div>

        <div className="sm:col-span-6">
          <Field
            name="b2.technicalInfrastructure.disconnectionMethod.enabled"
            component={CheckboxInput}
            label="Způsob odpojení"
          />
          {formik.values.b2?.technicalInfrastructure?.disconnectionMethod?.enabled && (
            <div className="pl-7 mt-3">
              <Field
                name="b2.technicalInfrastructure.disconnectionMethod.description"
                component={RichTextInput}
                aiHint="Způsob odpojení technické infrastruktury při odstraňování stavby"
              />
            </div>
          )}
        </div>
      </>
    </FormSectionTwoColumns>
  )
}
